import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:h-full" }
const _hoisted_2 = { class: "w-full grid grid-cols-12 gap-4 pb-4 text-darkgray-800" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Branch")
], -1)
const _hoisted_4 = { class: "col-span-8 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package"),
  /*#__PURE__*/_createElementVNode("p", { class: "pl-5 font-bold" }, "Add-ons")
], -1)
const _hoisted_6 = { class: "col-span-8 text-right" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date")
], -1)
const _hoisted_9 = { class: "col-span-8 text-right" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Time")
], -1)
const _hoisted_11 = { class: "col-span-8 text-right" }
const _hoisted_12 = { class: "w-full mt-auto text-darkgray-800" }
const _hoisted_13 = { class: "grid grid-cols-12 gap-4 pb-4 mb-4 border-b border-gray-40" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package Fee")
], -1)
const _hoisted_15 = { class: "col-span-8 text-right" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Misc. Fees")
], -1)
const _hoisted_17 = { class: "col-span-8 text-right" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-xl" }, "Total")
], -1)
const _hoisted_19 = { class: "col-span-6 text-right" }
const _hoisted_20 = { class: "font-bold text-xl" }

import ButtonComponent from '@/components/ButtonComponent.vue';

import PageLoader from "@/components/PageLoader.vue";
import { useBookingStore } from '@/store/booking';
import { computed, ref } from 'vue';
import { formatter } from "@/helpers/NumberHelper";



export default /*#__PURE__*/_defineComponent({
  __name: 'BookingSummary',
  props: {
    totalColor: {
        type: String,
    },
    defaultTitle: {
        type: Boolean,
        default: true
    },
    hideNotification: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {



// State Instance
const bookingStoreState = useBookingStore();

// Data
const loader = ref(false);
const selectedBranch = computed(() => bookingStoreState.bookingSummary?.selectedBranch);
const selectedPackage = computed(() => bookingStoreState.bookingSummary?.selectedPackage);
const selectedAddOns = computed(() => bookingStoreState.bookingSummary?.selectedAddOns);
const selectedDate = computed(() => bookingStoreState.bookingSummary?.selectedDate);
const selectedTime = computed(() => bookingStoreState.bookingSummary?.selectedTime);
const packageFee = computed(() => bookingStoreState.bookingSummary?.packageFee);
const miscFee = computed(() => bookingStoreState.bookingSummary?.miscFee);
const totalFee = computed(() => bookingStoreState.bookingSummary?.totalFee);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(selectedBranch.value || '--'), 1)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(selectedPackage.value || '--'), 1),
          (selectedAddOns.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedAddOns.value, (selectedAddOn, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "text-xs",
                  key: index
                }, _toDisplayString(selectedAddOn.item_name), 1))
              }), 128))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, "--"))
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", null, _toDisplayString(selectedDate.value || '--'), 1)
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(selectedTime.value || '--'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(packageFee.value) || 0.00), 1)
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(miscFee.value) || 0.00), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["grid grid-cols-12 gap-2.5 mb-5", __props.totalColor ? __props.totalColor : 'text-darkgray-800'])
        }, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(formatter).format(totalFee.value) || 0.00), 1)
          ])
        ], 2),
        _createVNode(ButtonComponent, {
          disabled: !_unref(bookingStoreState).canSubmitBooking,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('book-now')), ["prevent"])),
          class: "w-full",
          text: "Book Now"
        }, null, 8, ["disabled"])
      ])
    ]),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})